module.exports = __webpack_public_path__ + "img/foto_ozuv-2.24e35907.png";